import { AxiosResponse } from 'axios';
import { api } from 'services/companiesApi';

export const getDataCandidates = async (
	filters?: any,
): Promise<AxiosResponse> => {
	return await api.get('/candidates', { params: filters });
};

export const getHrUsers = async (): Promise<AxiosResponse> =>
	await api.get('/users');
